<template>
    <Modal size="md" @close="close">
        <div class="text-center">
            <h3>Tilføj betalingsmetode</h3>

            <PageLoader :loading="successful">
                <div class="m-xl m-center" style="max-width: 400px">
                    <div class="flex gap-2 px-[15px]">
                        <div class="flex-1 text-center">
                            <img src="/img/payment/visa.png" class="payment-icon" alt="Visa" />
                        </div>
                        <div class="flex-1 text-center">
                            <img
                                src="/img/payment/mastercard.png"
                                class="payment-icon"
                                alt="Visa"
                            />
                        </div>
                        <div class="flex-1 text-center">
                            <img src="/img/payment/american.png" class="payment-icon" alt="Visa" />
                        </div>
                        <div class="flex-1 text-center">
                            <img src="/img/payment/jcb.png" class="payment-icon" alt="Visa" />
                        </div>
                    </div>
                </div>
            </PageLoader>
            <form @submit.prevent="update">
                <div
                    class="well m-t-xl m-r-lg m-b-xl m-l-lg accent-t-sm text-left"
                    :class="successful ? 'hidden' : ''"
                >
                    <label class="m-b-md">
                        Kredit - eller debetkort
                    </label>
                    <div class="form-row">
                        <div ref="card"></div>
                        <div ref="card-errors" class="text-danger" role="alert"></div>
                    </div>
                    <FormItem field="stripe_token" :form="form"></FormItem>
                </div>

                <input
                    ref="hiddenInput"
                    type="tel"
                    style="border: 0px; color: transparent; width: 0px; height: 0px; background: transparent; font-size: 16px;"
                />

                <button class="btn btn-xl btn-load btn-success" :disabled="form.busy">
                    Gem betalingsmetode
                </button>
            </form>
        </div>
    </Modal>
</template>
<style lang="less" type="text/less">
.payment-icon {
    width: 90px;
    border-radius: 20px;
    border: 1px solid #ccc;
}
</style>
<script type="text/babel">
import FormItem from 'dashboard-js/components/utilities/FormItem'
import Modal from 'dashboard-js/components/Modal'
import PageLoader from 'dashboard-js/components/utilities/PageLoader'

export default {
    components: { FormItem, PageLoader, Modal },

    props: ['team'],

    data() {
        return {
            form: new SparkForm({
                stripe_token: null,
            }),
            stripe: null,
            card: null,
            successful: false,
        }
    },

    mounted() {
        this.initStripe().then(stripe => {
            this.stripe = stripe
            this.card = this.initCard(stripe)
            this.card.on('blur', () => this.blur)

            this.ready()
        })
    },

    methods: {
        blur() {
            // Fix stripe elements iphone bug
            this.$refs.hiddenInput.focus()
            this.$refs.hiddenInput.blur()
        },

        initStripe() {
            return new Promise(ready => {
                const setup = resolve => {
                    if (typeof Stripe !== 'function') {
                        return setTimeout(() => setup(resolve), 100)
                    }
                    resolve(Stripe(Spark.stripeKey))
                }
                setup(ready)
            })
        },

        initCard(stripe) {
            let card = stripe.elements().create('card', {
                style: {
                    base: {
                        // Add your base input styles here. For example:
                        fontSize: '16px',
                        //                            lineHeight: '24px',
                    },
                },
                hidePostalCode: true,
            })

            // Add an instance of the card Element into the `card-element` <div>
            card.mount(this.$refs['card'])
            card.addEventListener('change', ({ error }) => {
                const displayError = this.$refs['card-errors']
                if (error) {
                    displayError.textContent = error.message
                } else {
                    displayError.textContent = ''
                }
            })

            return card
        },

        ready() {
            this.form.busy = false
            this.successful = false

            setTimeout(() => this.card.focus(), 500)
        },

        update() {
            this.form.busy = true
            this.stripe.createToken(this.card).then(response => {
                if (response.error) {
                    this.form.busy = false
                } else {
                    this.blur()
                    this.card.clear()
                    this.form.stripe_token = response.token.id
                    this.successful = true

                    Spark.put(route('api.brand.payment-method.update', this.team.id), this.form)
                        .then(response => {
                            Bus.$emit('currentTeamUpdated', response.data)
                            this.close()
                        })
                        .catch(() => this.ready())
                }
            })
        },

        close() {
            this.$emit('close')
        },
    },
}
</script>
